export default __webpack_public_path__ + "static/media/polaroid7.a4f8d6b6.svg";